import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert
} from '@mui/material';
import {
  productTypes,
  setProductType,
  getProductType
} from '../../services/productTypeService';

interface Props {
  open: boolean;
  onClose: () => void;
  productId: string;
  productName: string;
  onSuccess?: () => void;
}

const ProductTypeManager: React.FC<Props> = ({
  open,
  onClose,
  productId,
  productName,
  onSuccess
}) => {
  const [selectedType, setSelectedType] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');

  useEffect(() => {
    if (open && productId) {
      loadCurrentType();
    }
  }, [open, productId]);

  const loadCurrentType = async () => {
    try {
      const typeData = await getProductType(productId);
      if (typeData) {
        setSelectedType(typeData.productType);
      }
    } catch (err) {
      console.error('Error loading type:', err);
    }
  };

  const handleSave = async () => {
    if (!selectedType) {
      setError('الرجاء اختيار نوع المنتج');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await setProductType(productId, selectedType);
      setSuccess('تم حفظ نوع المنتج بنجاح');
      if (onSuccess) onSuccess();
      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (err: any) {
      setError(err.response?.data?.message || 'حدث خطأ أثناء الحفظ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>تحديد نوع المنتج: {productName}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>نوع المنتج</InputLabel>
          <Select
            value={selectedType}
            label="نوع المنتج"
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <MenuItem value="">
              <em>غير محدد</em>
            </MenuItem>
            {productTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>إلغاء</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={loading}
        >
          {loading ? 'جاري الحفظ...' : 'حفظ'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductTypeManager;
